var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhoneIcon = function SvgPhoneIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5187 18.8312C6.99707 16.6339 3.50186 12.6437 1.27588 7.01866C0.719402 5.89365 0.719378 3.08115 4.05833 1.28114C4.89306 0.831141 5.7278 0.831134 6.84079 1.95615C7.95377 3.08116 6.84078 1.95614 7.95377 3.08114C9.23381 4.375 9.0976 5.5 8.875 6.0625C8.65241 6.7375 7.61987 7.35616 7.95377 8.70617C8.28766 10.0562 9.95714 11.8562 11.2927 12.0812C12.6283 12.3062 13.381 11.4625 13.9375 11.125C14.494 10.7875 15.4142 10.6222 16.3011 11.5187C16.75 11.9724 16.8576 12.0812 17.9706 13.2062C19.0836 14.3312 19.2094 15.2442 18.7497 16.0187C17.3125 18.9404 14.8946 19.2948 13.5187 18.8312Z",
    stroke: "#0A0C10",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone_icon.32c223d3.svg";
export { ForwardRef as ReactComponent };